import { useEffect, useState } from 'react';
import { sendNotification } from 'src/UI/Notification';
import { GET_MARKETS } from 'src/constants/EUMarkets';
import { get, isRequestCanceled } from 'src/services/GenesisApi';
import type { IMarketItem } from 'src/types/EUMarkets.type';

const useMarketFilters = () => {
  const [markets, setMarkets] = useState<string[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [reload, setReload] = useState(0);

  useEffect(() => {
    let active = true;
    const controller = new AbortController();
    setLoading(true);
    setError(false);
    get(GET_MARKETS, { signal: controller.signal })
      .then(({ data }: { data: IMarketItem[] }) => {
        if (active) {
          setMarkets(data.map((market) => market.marketName));
        }
      })
      .catch((cause: unknown) => {
        if (active && !isRequestCanceled(cause)) {
          setError(true);
          sendNotification({ type: 'error', message: 'Unable to load market filters.' });
        }
      })
      .finally(() => {
        if (active) {
          setLoading(false);
        }
      });
    return () => {
      active = false;
      controller.abort();
    };
  }, [reload]);

  return { markets, loading, error, retry: () => setReload((value) => value + 1) };
};

export default useMarketFilters;
